// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__8dnRQ","active":"NavigationItem_active__21Nvn"};